module.exports = __webpack_public_path__ + "static/media/refresh-3.d0d44726.svg";